import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../../store";
import { aboutMeType } from "../../../common/interfaces/myProfile/personalDetails/aboutMeType";
import { stat } from "fs";
// Define a type for the slice state

// Define the initial state using that type

const initialState: aboutMeType = {
  about_me: "",
};

const aboutMeSlice = createSlice({
  name: "aboutMe",

  initialState,
  reducers: {
    getAboutMe: (state: aboutMeType, action: PayloadAction<aboutMeType>) => {
      const payload = action.payload;
      state.about_me = payload.about_me;
    },
    updateAboutMe: (state: aboutMeType, action: PayloadAction<aboutMeType>) => {
      const payload = action.payload;
      state.about_me = payload.about_me;
    },
    resetAboutMe: (state: aboutMeType) => {
      state.about_me = "";
    },
  },
});

export const { getAboutMe, resetAboutMe, updateAboutMe } = aboutMeSlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default aboutMeSlice.reducer;
